export default __webpack_public_path__ + "static/media/shape4.8fad67c6.svg";